import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight, Check } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 bg-[#3D3229] text-[#FDF8F3] relative overflow-hidden" data-id="element-80">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-81">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#C4703F]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-82" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#8B9E7E]/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-83" />
      </div>

      <div className="container max-w-3xl mx-auto relative z-10 text-center" data-id="element-84">
        <FadeIn data-id="element-85">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#FDF8F3]" data-id="element-86">
            Empezá hoy mismo
          </h2>
          <p className="text-xl text-[#FDF8F3]/80 mb-10" data-id="element-87">
            Tu kit completo para recuperar la calma
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-88">
          <div className="bg-[#FDF8F3] text-[#3D3229] p-8 md:p-12 rounded-3xl shadow-2xl max-w-lg mx-auto transform transition-transform hover:scale-[1.02] duration-500" data-id="element-89">
            <div className="flex justify-center items-baseline gap-2 mb-8" data-id="element-90">
              <span className="text-sm font-medium text-[#3D3229]/60 uppercase tracking-wider" data-id="element-91">
                Por solo
              </span>
              <span className="text-5xl font-bold text-[#C4703F]" data-id="element-92">$10.000</span>
            </div>

            <ul className="space-y-4 text-left mb-10 max-w-xs mx-auto" data-id="element-93">
              <li className="flex items-center gap-3" data-id="element-94">
                <div className="w-5 h-5 rounded-full bg-[#8B9E7E] flex items-center justify-center text-white flex-shrink-0" data-id="element-95">
                  <Check className="w-3 h-3" data-id="element-96" />
                </div>
                <span data-id="element-97">Guía PDF de 7 días</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-98">
                <div className="w-5 h-5 rounded-full bg-[#8B9E7E] flex items-center justify-center text-white flex-shrink-0" data-id="element-99">
                  <Check className="w-3 h-3" data-id="element-100" />
                </div>
                <span data-id="element-101">3 audios guiados</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-102">
                <div className="w-5 h-5 rounded-full bg-[#8B9E7E] flex items-center justify-center text-white flex-shrink-0" data-id="element-103">
                  <Check className="w-3 h-3" data-id="element-104" />
                </div>
                <span data-id="element-105">Plantillas editables</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-106">
                <div className="w-5 h-5 rounded-full bg-[#8B9E7E] flex items-center justify-center text-white flex-shrink-0" data-id="element-107">
                  <Check className="w-3 h-3" data-id="element-108" />
                </div>
                <span data-id="element-109">Acceso de por vida</span>
              </li>
            </ul>

            <a href="https://tuaurasimple.com/cart/54058723541295:1" target="_blank" rel="noopener noreferrer" className="w-full group inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-300 bg-[#C4703F] rounded-xl hover:bg-[#A65D33] hover:shadow-lg hover:shadow-[#C4703F]/20 hover:-translate-y-0.5 no-underline" data-id="element-110">
              Descargalo ahora
              <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-111" />
            </a>
            <p className="mt-4 text-xs text-[#3D3229]/50" data-id="element-112">
              Pago único y seguro. Entrega inmediata por email.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}